import './Progress.css'

export function Progress({ value = 0, className = '' }) {
  return (
    <div className={`progress ${className}`} role="progressbar" aria-valuenow={value} aria-valuemin="0" aria-valuemax="100">
      <div className="progress-bar" style={{ width: `${value}%` }} />
    </div>
  )
}

